<template>
  <div
    class="modal fade text-left"
    id="adminAddUserModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="adminAddUserModalLabel"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header bg-spnm text-white">
          <h6 class="modal-title" id="adminAddUserModalLabel">
            <i class="fas fa-user-plus mr-2"></i>Add New User
          </h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="resetForm">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body custom-scroller">
          <form @submit.prevent="saveUser">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>First Name <span class="text-danger">*</span></label>
                <input v-model="form.firstName" type="text" class="form-control form-control-sm" maxlength="50" required />
              </div>
              <div class="form-group col-md-6">
                <label>Last Name <span class="text-danger">*</span></label>
                <input v-model="form.lastName" type="text" class="form-control form-control-sm" maxlength="50" required />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Personal Email <span class="text-danger">*</span></label>
                <input v-model="form.personalEmailId" type="email" class="form-control form-control-sm" maxlength="254" required />
              </div>
              <div class="form-group col-md-6">
                <label>Official Email <span class="text-danger">*</span></label>
                <input v-model="form.officialEmailId" type="email" class="form-control form-control-sm" maxlength="254" required />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Gender <span class="text-danger">*</span></label>
                <select v-model="form.gender" class="form-control form-control-sm" required>
                  <option value="">-- Select --</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label>Birth Date <span class="text-danger">*</span></label>
                <input v-model="form.birthDate" type="date" class="form-control form-control-sm" required />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Highest Education <span class="text-danger">*</span></label>
                <input v-model="form.highestEducation" type="text" class="form-control form-control-sm" maxlength="254" required />
              </div>
              <div class="form-group col-md-6">
                <label>Membership Plan <span class="text-danger">*</span></label>
                <select v-model="form.membershipPlan" class="form-control form-control-sm" required :disabled="membershipPlans.length === 1">
                  <option value="">-- Select --</option>
                  <option v-for="plan in membershipPlans" :key="plan.gpId" :value="plan.gpId">
                    {{ plan.shortDescription }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Industry/Vertical <span class="text-danger">*</span></label>
                <select v-model="form.industryVertical" class="form-control form-control-sm" required @change="onIndustryChange">
                  <option value="">-- Select --</option>
                  <option v-for="v in industryVerticals" :key="v.gpId" :value="v.gpId">{{ v.shortDescription }}</option>
                  <option value="0">Others</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label>Other Industry/Vertical</label>
                <input
                  v-model="form.otherIndustryVertical"
                  type="text"
                  class="form-control form-control-sm"
                  maxlength="249"
                  :disabled="form.industryVertical != '0' && form.industryVertical !== 0"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Company Name <span class="text-danger">*</span></label>
                <input v-model="form.companyName" type="text" class="form-control form-control-sm" maxlength="254" required />
              </div>
              <div class="form-group col-md-6">
                <label>Job Title/Position <span class="text-danger">*</span></label>
                <input v-model="form.jobTitle" type="text" class="form-control form-control-sm" maxlength="254" required />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Personal Mobile No. <span class="text-danger">*</span></label>
                <input v-model="form.personalMobileNo" type="text" class="form-control form-control-sm" maxlength="13" required />
              </div>
              <div class="form-group col-md-6">
                <label>Alternative Mobile No.</label>
                <input v-model="form.alternativeMobileNo" type="text" class="form-control form-control-sm" maxlength="13" />
              </div>
            </div>

            <div class="form-group">
              <label>Preferred Address <span class="text-danger">*</span></label>
              <textarea v-model="form.address" class="form-control form-control-sm" rows="2" maxlength="999" required></textarea>
            </div>

            <div v-if="errorMessage" class="alert alert-danger py-2" role="alert">
              <i class="fas fa-exclamation-circle mr-1"></i>{{ errorMessage }}
            </div>
            <div v-if="successMessage" class="alert alert-success py-2" role="alert">
              <i class="fas fa-check-circle mr-1"></i>{{ successMessage }}
            </div>

            <div class="modal-footer px-0">
              <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="resetForm">Cancel</button>
              <button type="submit" class="btn btn-spnm btn-sm" :disabled="saving">
                <span v-if="saving"><i class="fas fa-sync-alt fa-spin mr-1"></i>Saving...</span>
                <span v-else><i class="fas fa-save mr-1"></i>Save User</span>
              </button>
            </div>
          </form>
        </div>

        <div v-if="saving" class="overlay">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

export default {
  name: "AdminAddUserModal",
  data() {
    return {
      saving: false,
      errorMessage: null,
      successMessage: null,
      industryVerticals: [],
      membershipPlans: [],
      form: this.emptyForm(),
    };
  },
  created() {
    this.loadIndustryVerticals();
    this.loadMembershipPlans();
  },
  methods: {
    emptyForm() {
      return {
        userId: 0,
        firstName: null,
        lastName: null,
        personalEmailId: null,
        officialEmailId: null,
        gender: "",
        birthDate: null,
        highestEducation: null,
        industryVertical: "",
        otherIndustryVertical: null,
        companyName: null,
        jobTitle: null,
        personalMobileNo: null,
        alternativeMobileNo: null,
        address: null,
        membershipPlan: "",
        active: "Y",
        membershipInfo: {
          membershipId: 0,
          transactionDetailInformation: {
            gatewayTransactionInfo: {
              amountPaid: 0,
              paymentId: "NA",
              signature: "NA",
              paymentOrderId: "NA",
              transactionType: 3,
            },
          },
        },
      };
    },
    resetForm() {
      this.form = this.emptyForm();
      this.errorMessage = null;
      this.successMessage = null;
    },
    onIndustryChange() {
      this.form.otherIndustryVertical = "";
    },
    loadIndustryVerticals() {
      axios
        .post("/api/GeneralPurpose/GPByGPType", { gpType: "IndustryVertical" })
        .then((resp) => {
          this.industryVerticals = resp.data.generalPurposeItems || [];
        })
        .catch(() => {});
    },
    loadMembershipPlans() {
      axios
        .post("/api/GeneralPurpose/GPByGPType", { gpType: "MembershipType" })
        .then((resp) => {
          this.membershipPlans = resp.data.generalPurposeItems || [];
          if (this.membershipPlans.length === 1) {
            this.form.membershipPlan = this.membershipPlans[0].gpId;
          }
        })
        .catch(() => {});
    },
    saveUser() {
      this.saving = true;
      this.errorMessage = null;
      this.successMessage = null;

      const payload = Object.assign({}, this.form);
      payload.industryVertical = parseInt(payload.industryVertical) || 0;
      payload.membershipPlan = parseInt(payload.membershipPlan) || 0;

      axios
        .post("/api/Membership/AdminRegister", payload)
        .then(() => {
          this.successMessage = "User registered successfully!";
          this.saving = false;
          this.$emit("saved");
          setTimeout(() => {
            $("#adminAddUserModal").modal("hide");
            this.resetForm();
          }, 1200);
        })
        .catch((error) => {
          this.saving = false;
          if (error.response && error.response.data) {
            const data = error.response.data;
            this.errorMessage = Array.isArray(data) ? data.join(" ") : data;
          } else {
            this.errorMessage = "An error occurred. Please try again.";
          }
        });
    },
  },
};
</script>

<style scoped>
.overlay {
  border-radius: 0.25rem;
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  z-index: 9999;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
